var _circle, _path, _rect, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FE815F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4277 39.143C19.4277 31.5688 25.5678 25.4287 33.142 25.4287H46.8563C54.4305 25.4287 60.5706 31.5688 60.5706 39.143V55.143C60.5706 57.6677 58.5239 59.7144 55.9992 59.7144H23.9992C21.4744 59.7144 19.4277 57.6677 19.4277 55.143V49.4287H18.2857C17.0233 49.4287 16 48.4053 16 47.143V42.5716C16 41.3092 17.0233 40.2858 18.2857 40.2858H19.4277V39.143ZM61.7143 40.2858C62.9767 40.2858 64 41.3092 64 42.5716V47.143C64 48.4053 62.9767 49.4287 61.7143 49.4287H60.5714V40.2858H61.7143Z",
    fill: "url(#paint0_linear_47971_102030)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 38,
    width: 32,
    height: 11.4286,
    rx: 5.71429,
    fill: "#FE815F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9986 46.0001C33.261 46.0001 34.2843 44.9768 34.2843 43.7144C34.2843 42.4521 33.261 41.4287 31.9986 41.4287C30.7362 41.4287 29.7129 42.4521 29.7129 43.7144C29.7129 44.9768 30.7362 46.0001 31.9986 46.0001ZM47.9986 46.0001C49.261 46.0001 50.2843 44.9768 50.2843 43.7144C50.2843 42.4521 49.261 41.4287 47.9986 41.4287C46.7362 41.4287 45.7129 42.4521 45.7129 43.7144C45.7129 44.9768 46.7362 46.0001 47.9986 46.0001Z",
    fill: "url(#paint1_linear_47971_102030)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0006 18.2658C48.6839 17.8706 49.1437 17.1319 49.1437 16.2857C49.1437 15.0233 48.1203 14 46.858 14C45.5956 14 44.5723 15.0233 44.5723 16.2857C44.5723 17.1316 45.0318 17.8702 45.7148 18.2655V25.4285H48.0006V18.2658ZM35.4289 19.7143C35.4289 20.5604 34.9691 21.2992 34.2857 21.6944V25.4286H32V21.6941C31.317 21.2988 30.8574 20.5602 30.8574 19.7143C30.8574 18.4519 31.8808 17.4286 33.1431 17.4286C34.4055 17.4286 35.4289 18.4519 35.4289 19.7143Z",
    fill: "url(#paint2_linear_47971_102030)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47971_102030",
    x1: 40,
    y1: 25.4287,
    x2: 40,
    y2: 59.7144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47971_102030",
    x1: 39.9986,
    y1: 41.4287,
    x2: 39.9986,
    y2: 46.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47971_102030",
    x1: 40.0006,
    y1: 11.7143,
    x2: 40.0006,
    y2: 25.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotAvatar);
export default __webpack_public_path__ + "static/media/bot-avatar.4c253b27ef091d784e90fc0936198279.svg";
export { ForwardRef as ReactComponent };